(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["corelewear-photo-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clw-photo-reviews')) {
    class ClwPhotoReviews extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.strip = this.querySelector('[data-strip]');
        this.dialog = this.querySelector('[data-dialog]');
        this.dialogBody = this.querySelector('[data-dialog-body]');
        this.max = Math.min(Math.max(Number(this.dataset.max) || 8, 1), 12);
        this.showStars = this.dataset.showStars === 'true';
        this.showNames = this.dataset.showNames === 'true';

        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.prev?.addEventListener('click', () => this.scrollByPage(-1));
        this.next?.addEventListener('click', () => this.scrollByPage(1));
        this.strip?.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());

        this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        const native = this.fromNative();
        if (native.length) {
          this.show(native);
          return;
        }

        const embedded = this.fromEmbedded();
        if (embedded.length) {
          this.show(embedded);
          return;
        }

        const start = () => {
          if ('requestIdleCallback' in window) window.requestIdleCallback(() => this.load(), { timeout: 2500 });
          else setTimeout(() => this.load(), 800);
        };
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true });
      }

      readJson(selector) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || 'null');
        } catch (e) {
          return null;
        }
      }

      isHttps(value) {
        try {
          return new URL(value).protocol === 'https:';
        } catch (e) {
          return false;
        }
      }

      fromNative() {
        const data = this.readJson('[data-native-data]');
        if (!Array.isArray(data)) return [];
        const items = [];
        for (const row of data) {
          if (!row || !this.isHttps(row.url)) continue;
          const sep = row.url.includes('?') ? '&' : '?';
          items.push({
            review: { rating: row.rating, title: row.title, body: row.body, reviewer: { displayName: row.name, isVerified: row.verified === true } },
            photo: { thumb: row.url + sep + 'width=320', large: row.url + sep + 'width=1200', alt: '' },
          });
          if (items.length >= this.max) break;
        }
        return items;
      }

      fromEmbedded() {
        const data = this.readJson('[data-oke-data]');
        const media = data && data.media;
        const reviews = data && data.reviews;
        if (!Array.isArray(media)) return [];
        const byId = new Map((Array.isArray(reviews) ? reviews : []).map((review) => [review.reviewId, review]));
        const items = [];
        for (const item of media) {
          if (!item || (item.type && String(item.type).toLowerCase() !== 'image')) continue;
          const urls = item.imageUrls || {};
          const thumb = String(urls.thumbnailUrl || urls.largeUrl || '').replace('d=120x120', 'd=320x320');
          const large = urls.largeUrl || urls.fullSizeUrl || urls.thumbnailUrl;
          if (!this.isHttps(thumb) || !this.isHttps(large)) continue;
          items.push({ review: byId.get(item.reviewId) || null, photo: { thumb, large, alt: item.imageAlt || '' } });
          if (items.length >= this.max) break;
        }
        return items;
      }

      subscriberId() {
        const own = (this.dataset.subscriberId || '').trim();
        if (own) return own;
        try {
          const settings = JSON.parse(document.getElementById('oke-reviews-settings')?.textContent || '{}');
          return settings.subscriberId || '';
        } catch (e) {
          return '';
        }
      }

      pickPhoto(review) {
        const media = Array.isArray(review && review.media) ? review.media : [];
        for (const item of media) {
          if (!item) continue;
          if (item.type && String(item.type).toLowerCase() !== 'image') continue;
          const thumb = item.thumbnailUrl || item.largeUrl || item.fullSizeUrl || item.url;
          const large = item.largeUrl || item.fullSizeUrl || item.url || item.thumbnailUrl;
          if (this.isHttps(thumb) && this.isHttps(large)) return { thumb, large, alt: item.alt || '' };
        }
        return null;
      }

      async fetchPage(url) {
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        return response.json();
      }

      async load() {
        const productId = this.dataset.productId;
        const subscriberId = this.subscriberId();
        if (!productId || !subscriberId) return;

        const base = 'https://api.okendo.io/v1';
        const root = base + '/stores/' + encodeURIComponent(subscriberId) + '/products/shopify-' + encodeURIComponent(productId) + '/reviews?limit=50';
        const items = [];

        try {
          let url = root + '&orderBy=has_media%20desc';
          for (let page = 0; page < 3 && url && items.length < this.max; page++) {
            let data = await this.fetchPage(url);
            if (!data && page === 0) data = await this.fetchPage(root);
            if (!data) break;
            for (const review of data.reviews || []) {
              const photo = this.pickPhoto(review);
              if (photo) items.push({ review, photo });
              if (items.length >= this.max) break;
            }
            const next = data.nextUrl ? (String(data.nextUrl).startsWith('http') ? data.nextUrl : base + data.nextUrl) : null;
            url = next && next.startsWith(base + '/') ? next : null;
          }
        } catch (e) {
          return;
        }

        if (items.length) this.show(items);
      }

      show(items) {
        this.render(items);
        this.hidden = false;
        this.updateArrows();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.updateArrows());
      }

      scrollByPage(direction) {
        if (!this.strip) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.strip.scrollBy({ left: direction * this.strip.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.strip || !this.prev || !this.next) return;
        const max = this.strip.scrollWidth - this.strip.clientWidth;
        const scrollable = max > 4;
        this.prev.hidden = !scrollable || this.strip.scrollLeft <= 4;
        this.next.hidden = !scrollable || this.strip.scrollLeft >= max - 4;
      }

      stars(value) {
        const rating = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
        return '★'.repeat(rating) + '☆'.repeat(5 - rating);
      }

      displayName(review) {
        return (review && review.reviewer && review.reviewer.displayName) || '';
      }

      render(items) {
        this.strip.textContent = '';
        for (const { review, photo } of items) {
          const name = this.displayName(review);
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'clw-photo-reviews__card';
          card.setAttribute('aria-label', name ? 'Open photo review by ' + name : 'Open customer photo');

          const image = document.createElement('img');
          image.src = photo.thumb;
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 240;
          image.height = 240;
          card.append(image);

          if (this.showStars && review && review.rating) {
            const stars = document.createElement('span');
            stars.className = 'clw-photo-reviews__stars';
            stars.setAttribute('aria-hidden', 'true');
            stars.textContent = this.stars(review.rating);
            card.append(stars);
          }
          if (this.showNames && name) {
            const label = document.createElement('span');
            label.className = 'clw-photo-reviews__name';
            label.textContent = name;
            card.append(label);
          }

          if (!card.querySelector('.clw-photo-reviews__stars, .clw-photo-reviews__name') && (this.showStars || this.showNames)) {
            const spacer = document.createElement('span');
            spacer.className = 'clw-photo-reviews__spacer';
            spacer.setAttribute('aria-hidden', 'true');
            card.append(spacer);
          }

          card.addEventListener('click', () => this.open(review, photo));
          this.strip.append(card);
        }
      }

      open(review, photo) {
        if (!this.dialog || !this.dialogBody) return;
        this.dialogBody.textContent = '';
        const name = this.displayName(review);

        const image = document.createElement('img');
        image.src = photo.large;
        image.alt = photo.alt || (name ? 'Photo from ' + name : 'Customer photo');
        this.dialogBody.append(image);

        if (review) {
          const text = document.createElement('div');
          text.className = 'clw-photo-reviews__text';

          if (review.rating) {
            const stars = document.createElement('div');
            stars.className = 'clw-photo-reviews__stars';
            stars.textContent = this.stars(review.rating);
            text.append(stars);
          }
          if (name) {
            const who = document.createElement('div');
            who.className = 'clw-photo-reviews__who';
            who.textContent = name + (review.reviewer && review.reviewer.isVerified === true ? ' · ' + (this.dataset.verifiedLabel || 'Verified Buyer') : '');
            text.append(who);
          }
          if (review.title) {
            const title = document.createElement('p');
            title.className = 'clw-photo-reviews__title';
            title.textContent = review.title;
            text.append(title);
          }
          if (review.body) {
            const body = document.createElement('p');
            body.className = 'clw-photo-reviews__body';
            body.textContent = review.body;
            text.append(body);
          }
          if (text.children.length) this.dialogBody.append(text);
        }

        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      }
    }
    customElements.define('clw-photo-reviews', ClwPhotoReviews);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["corelewear-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clw-size-toggle')) {
    const BAND_ES = { '40': '90', '42': '95', '44': '100', '46': '105' };
    const CUP_ES = { B: 'B', C: 'C', D: 'D', DD: 'E', DDD: 'F' };

    // Option values are US sizes. Returns the label to show, or null when the value is not a band/cup size.
    const labelFor = (value, system) => {
      const v = String(value || '').trim().toUpperCase();
      if (BAND_ES[v]) return system === 'es' ? BAND_ES[v] : v;
      if (CUP_ES[v]) return system === 'es' ? CUP_ES[v] : v;
      const combined = v.match(/^(40|42|44|46)(B|C|DDD|DD|D)$/);
      if (combined) {
        return system === 'es' ? BAND_ES[combined[1]] + CUP_ES[combined[2]] : v;
      }
      return null;
    };

    class ClwSizeToggle extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.dialog = this.querySelector('[data-dialog]');
        this.root = this.closest('section') || document;
        // Sizes are shown in the Spanish / EU system only (option values stay US inside the form).
        this.system = 'es';
        this.paint();

        this.querySelector('[data-open]')?.addEventListener('click', () => this.open());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-close]')) this.dialog.close();
        });

        // The product form re-renders after a variant change: re-apply the labels.
        this.observer = new MutationObserver(() => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.apply();
          });
        });
        this.observer.observe(this.root, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.started = false;
      }

      paint() {
        this.apply();
      }

      apply() {
        const system = this.system;
        this.root.querySelectorAll('select option').forEach((option) => {
          const label = labelFor(option.value, system);
          if (label !== null && option.textContent.trim() !== label) option.textContent = label;
        });
        // Selected variant shown in the sticky add-to-cart bar, e.g. "White / 40 / B".
        this.root.querySelectorAll('.sticky-add-to-cart__variant').forEach((element) => {
          const parts = element.textContent.split('/').map((part) => part.trim());
          if (parts.length < 2) return;
          const text = parts.map((part) => labelFor(part, system) ?? part).join(' / ');
          if (element.textContent.trim() !== text) element.textContent = text;
        });
        this.root.querySelectorAll('.variant-option__button-label input[type="radio"]').forEach((input) => {
          const label = labelFor(input.value, system);
          if (label === null) return;
          if (input.getAttribute('aria-label') !== label) input.setAttribute('aria-label', label);
          const text = input.closest('label')?.querySelector('.variant-option__button-label__text');
          if (text && text.textContent.trim() !== label) text.textContent = label;
        });
      }

      open() {
        if (!this.dialog) return;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
      }
    }
    customElements.define('clw-size-toggle', ClwSizeToggle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["corelewear-stock-alert"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clw-stock-alert')) {
    class ClwStockAlert extends HTMLElement {
      connectedCallback() {
        try {
          this.stock = JSON.parse(this.querySelector('[data-stock]')?.textContent || '{}');
        } catch (e) {
          this.stock = {};
        }
        this.textEl = this.querySelector('[data-stock-text]');
        this.template = this.querySelector('[data-stock-template]')?.innerHTML || 'Only [count] left in [variant]';
        this.threshold = Number(this.dataset.threshold || 5);
        this.section = this.closest('.shopify-section') || document;

        this.onChange = () => setTimeout(() => this.update(), 60);
        this.section.addEventListener('change', this.onChange);
        this.observer = new MutationObserver(this.onChange);
        this.section
          .querySelectorAll('form input[name="id"]')
          .forEach((input) => this.observer.observe(input, { attributes: true, attributeFilter: ['value'] }));
        this.update();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
      }

      update() {
        const id = this.section.querySelector('form input[name="id"]')?.value;
        const entry = id && this.stock[id];
        if (!this.textEl) return;
        if (!entry || entry.q < 1 || entry.q > this.threshold) {
          this.textEl.hidden = true;
          return;
        }
        this.textEl.textContent = this.template
          .replace('[count]', String(entry.q))
          .replace('[variant]', entry.t);
        this.textEl.hidden = false;
      }
    }
    customElements.define('clw-stock-alert', ClwStockAlert);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["corelewear-variant-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clw-variant-note')) {
    class ClwVariantNote extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section') || document;
        this.onChange = (event) => {
          const target = event.target;
          if (!(target instanceof Element) || !target.closest('variant-picker')) return;
          if (!this.scope.contains(target)) return;
          this.update();
        };
        document.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onChange);
      }

      update() {
        const colors = (this.dataset.colors || '')
          .split(',')
          .map((c) => c.trim())
          .filter(Boolean);
        const selected = [];
        this.scope.querySelectorAll('variant-picker input[type="radio"]:checked').forEach((input) => {
          selected.push(input.value.trim().toLowerCase());
        });
        this.scope.querySelectorAll('variant-picker select').forEach((select) => {
          selected.push(select.value.trim().toLowerCase());
        });
        this.hidden = !selected.some((value) => colors.includes(value));
      }
    }
    customElements.define('clw-variant-note', ClwVariantNote);
  }
  } catch(e) { console.error(e); }
})();

})();
